import { useMutation } from "@tanstack/react-query";
import { getCheckProsPartners, ParamsCheckProsPartners, ResponseGetCheckProsPartners } from "@/api/contractors/get-check-pros-partners";
import { useMixpanel } from "@/third-party/mixpanel/useMixpanel";

export default function usePartners({ onSuccess }: Params = {}) {
  const mixpanel = useMixpanel();
  async function mutationFn(params: MutationParams) {
    const form = {
      zip: params.zip,
      service: params.service,
      question: params.questions,
      email: params.email,
      n_phone: params.phone,
    } satisfies ParamsCheckProsPartners;
    const response = await getCheckProsPartners(form);
    const data = response.response.return_data;

    mixpanel.track("Matches NX Pros", {
      page: params.pageName,
      'NX Task': data.nx_task,
      'On Platform': data.stay_on_platform,
    });

    if (data.tt_task) {
      mixpanel.track("Thumbtack Matches Pros", {
        page: params.pageName,
        'NX Task': data.nx_task,
        'TT Task': data.tt_task,
        'found': data.tt_pros.length,
      });
    }

    if (data.redirect_to_thumbtack) {
      redirectToThumbtack({ zip: form.zip, service: form.service, questions: form.question });
      return {
        type: "redirect" as const,
      };
    }

    return {
      type: "stay" as const,
      data,
      success: true,
    };
  }

  return useMutation({
    onSuccess: (data: Awaited<ReturnType<typeof mutationFn>>) => onSuccess?.(data?.data),
    mutationFn,
  });
}

interface MutationParams {
  zip: string;
  service: number;
  questions: Record<string, string>;
  /** not all use-cases have this param when doing the partners flow */
  email?: string;
  /** not all use-cases have this param when doing the partners flow */
  phone?: string;
  pageName: string;
}

interface Params {
  onSuccess?: (data: ResponseGetCheckProsPartners | undefined) => void;
}

function redirectToThumbtack(data: { zip: string; service: number; questions: Record<string, string> }) {
  const questionsParam = Object
    .entries(data.questions)
    .map(([question, answer]) => `question[${question}]=${answer}`)
    .join("&");
  const url = `/thumbtack.php?zip=${data.zip}&service=${data.service}&${questionsParam}`;
  window.location.href = url;
}
